export default [
  {
    id: '-11',
    name: '(SST) Midway Islands, American Samoa',
    label: 'SST',
  },
  {
    id: '-10',
    name: '(HDT) Hawaii, Tahiti, Cook Islands',
    label: 'HDT',
  },
  {
    id: '-8',
    name: '(AKDT) Alaska',
    label: 'AKDT',
  },
  {
    id: '-7',
    name: '(PDT) Pacific Daylight Time (LA, Vancouver)',
    label: 'PDT',
  },
  {
    id: '-6',
    name: '(MDT) Mountain Daylight Time (Denver, SLC)',
    label: 'MDT',
  },
  {
    id: '-5',
    name: '(CDT) Central Daylight Time (Mexico, Chicago)',
    label: 'CDT',
  },
  {
    id: '-4',
    name: '(EDT) Eastern Daylight Time (NYC, Toronto)',
    label: 'EDT',
  },
  {
    id: '-3',
    name: '(BRT) Brasília, São Paulo, Buenos Aires',
    label: 'BRT',
  },
  {
    id: '-2',
    name: '(FNT) South Sandwich Islands',
    label: 'FNT',
  },
  {
    id: '-1',
    name: '(AZOT) Azores, Cape Verde (Praia)',
    label: 'AZOT',
  },
  {
    id: '0',
    name: '(GMT) Iceland',
    label: 'GMT',
  },
  {
    id: '+1',
    name: '(WEST) Western European Summer Time (London, Lisbon)',
    label: 'WEST',
  },
  {
    id: '+2',
    name: '(CEST) Central European Summer Time (Rome, Paris)',
    label: 'CEST',
  },
  {
    id: '+3',
    name: '(EEST) Eastern European Summer Time',
    label: 'EEST',
  },
  {
    id: '+3.5',
    name: '(IRST) Iran Standard Time (Tehran)',
    label: 'IRST',
  },
  {
    id: '+4',
    name: '(MSK) Moscow, St. Petersburg, Dubai',
    label: 'MSK',
  },
  {
    id: '+4.5',
    name: '(AFT) Afghanistan Time (Kabul)',
    label: 'AFT',
  },
  {
    id: '+5',
    name: '(MVT) Karachi, Tashkent, Maldive Islands',
    label: 'MVT',
  },
  {
    id: '+5.5',
    name: '(IST) India Standard Time (Mumbai, Colombo)',
    label: 'IST',
  },
  {
    id: '+6',
    name: '(BST) Yekaterinburg, Almaty, Dhaka',
    label: 'BST',
  },
  {
    id: '+7',
    name: '(ICT) Bangkok, Hanoi, Jakarta',
    label: 'ICT',
  },
  {
    id: '+8',
    name: '(CST) Beijing, Perth, Singapore, Hong Kong',
    label: 'CST',
  },
  {
    id: '+9',
    name: '(JST) Tokyo, Seoul',
    label: 'JST',
  },
  {
    id: '+9.5',
    name: '(ACT) ACST (Darwin, Adelaide)',
    label: 'ACT',
  },
  {
    id: '+10',
    name: '(AEST) AEST (Brisbane, Sydney), Yakutsk',
    label: 'AEST',
  },
  {
    id: '+11',
    name: '(NCT) Nouméa, Solomon Islands',
    label: 'NCT',
  },
  {
    id: '+12',
    name: '(NZST) Auckland, Fiji, Marshall Islands',
    label: 'NZST',
  },
  {
    id: '+13',
    name: '(TKT) Fakaofo',
    label: 'TKT',
  },
]
